import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { View } from 'react-native';
import { Button, Typography } from '@hmsexp/component-library';
import { SparkLineStyling } from './style';
import { getLineChartSymbol, underscoreToText } from '../../../containers/OnlineReview/utils';

const SparkLine = props => {
  const {
    index,
    data,
    label,
    subLabel,
    name,
    chartType = 'line',
    color,
    handleCtaClick,
    ctaText,
    variant = 'default'
  } = props;

  const styles = SparkLineStyling(color);

  function getChartHeight() {
    return chartType === 'line' ? (variant === 'compact' ? 35 : 50) : 100;
  }

  const getSparklineOptions = (name, data, color, index) => {
    const lastPointIndex = data.length - 1;
    const lastPointValue = data[lastPointIndex];

    const smallChartoption = {
      chart: {
        type: chartType,
        height: getChartHeight(),
        width: variant === 'compact' ? 70 : 200
      },
      title: { text: ' ' },
      xAxis: { visible: false },
      yAxis: { visible: false },
      tooltip: { enabled: false },
      exporting: { enabled: false },
      credits: { enabled: false },
      series: [
        {
          name: ' ',
          data,
          color,
          marker: { enabled: false },
          states: { hover: { enabled: false } },
          showInLegend: false,
          shadow: {
            color,
            offsetX: 0,
            offsetY: 2,
            opacity: 0.15,
            width: 8
          }
        }
      ]
    };

    if (chartType === 'line') {
      smallChartoption.series.push({
        type: 'scatter',
        name: ' ',
        data: [[lastPointIndex, lastPointValue]],
        marker: {
          radius: 5,
          fillColor: color,
          symbol: getLineChartSymbol(index)
        },
        states: { hover: { enabled: false } },
        enableMouseTracking: false,
        showInLegend: false
      });
    }

    return smallChartoption;
  };

  const options = getSparklineOptions(name, data, color, index);
  if (variant === 'compact') {
    return (
      <View style={styles.compactContainer}>
        <Typography style={styles.headerTitle} variant='button' fontWeightType='regular'>
          {underscoreToText(name)}
        </Typography>

        <View style={styles.mainRow}>
          <View style={styles.leftColumn}>
            <Typography style={styles.primaryValue} variant='h5' fontWeightType='bold'>
              {label?.value}
            </Typography>
          </View>

          <View style={styles.rightColumnChart}>
            <HighchartsReact highcharts={Highcharts} options={options} />
          </View>
        </View>
        <View style={styles.subRow}>
          <View style={styles.maxWidthLabel}>
            <Typography variant='micro' fontWeightType='regular'>
              {label?.label}
            </Typography>
          </View>
          <View style={styles.maxWidthLabel}>
            <Typography variant='button' fontWeightType='regular'>
              {subLabel?.value}
            </Typography>
          </View>
          <View style={styles.maxWidthLabel}>
            <Typography variant='micro' fontWeightType='regular'>
              {subLabel?.label}
            </Typography>
          </View>
        </View>

        {ctaText && (
          <Button
            title={ctaText}
            onClick={() => handleCtaClick(name)}
            size='small'
            style={{
              buttonContainer: styles.ctaButton,
              buttonText: styles.ctaButtonText,
            }}
          />
        )}
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <View style={styles.innerContainer}>
        <View style={styles.chartContainer}>
          <Typography variant='button' fontWeightType='regular'>
            {underscoreToText(name)}
          </Typography>

          <HighchartsReact highcharts={Highcharts} options={options} />
        </View>

        <View style={styles.dataContainer}>
          <View style={styles.dataFlexContainer}>
            <Typography variant='h5' fontWeightType='bold'>
              {label?.value}
            </Typography>
            <Typography textProps={{ style: styles.dataMicroText }} variant='micro'>
              {label?.label}
            </Typography>
          </View>

          <View style={styles.dataFlexContainer}>
            <Typography variant='button'>{subLabel?.value}</Typography>
            <Typography textProps={{ style: styles.dataMicroText }} variant='micro'>
              {subLabel?.label}
            </Typography>
          </View>
        </View>
      </View>
    </View>
  );
};

export default SparkLine;
